export const setElementStyle = (elem, style) => {
  Object.entries(style).forEach(([key, value]) => {
    // hack to apply !important priority on CSS
    if (Array.isArray(value)) {
      elem.style.setProperty(key, value[0], value[1]);
    } else elem.style.setProperty(key, value);
  });
  return elem;
};

export const setElemAttributes = (elem, attributes) => {
  Object.entries(attributes).forEach(([key, value]) => {
    if (key == 'style') setElementStyle(elem, value);
    else if (key == 'events') {
      Object.entries(value).forEach(([spec, clb]) => {
        elem.addEventListener(spec, clb);
      });
    } else elem.setAttribute(key, value);
  });
};

export const createElement = (elemName, attributes = {}, children) => {
  const elem = document.createElement(elemName);
  setElemAttributes(elem, attributes);
  if (Array.isArray(children)) {
    children.forEach(child => elem.appendChild(child));
  } else if (children) elem.appendChild(children);
  return elem;
};

export const Button = (attributes, children) => createElement('button', attributes, children);

export const Div = (attributes, children) => createElement('div', attributes, children);

export const Span = (attributes, children) => createElement('span', attributes, children);

export const Img = (attributes, children) => createElement('img', attributes, children);

export const Br = (attributes, children) => createElement('br', attributes, children);

export const Text = text => document.createTextNode(text);

export const MultilinesText = text => {
  if (!text?.split) return [];

  const lines = text.split(/<br\s*\/?>/i);
  const elements = [];
  lines.forEach((line, i) => {
    elements.push(Text(line));
    if (i < lines.length - 1) {
      elements.push(Br());
    }
  });
  return elements;
};
